import type { Dispatch, SetStateAction } from "react";
import { createPortal } from "react-dom";
import AdminTournamentMatchupModal, {
  type AdminTournamentMatchupModalState,
} from "./AdminTournamentMatchupModal";
import AdminTournamentScoreModal, {
  type AdminTournamentScoreModalState,
} from "./AdminTournamentScoreModal";
import type { AdminTournamentManualPair } from "../hooks/useAdminTournamentResources";

type AdminTournamentOperationsModalsProps = {
  manualPairs: AdminTournamentManualPair[];
  matchupModal: AdminTournamentMatchupModalState | null;
  onCloseMatchup: () => void;
  onCloseScore: () => void;
  onSaveMatchup: () => void;
  onSaveScore: () => void;
  saving: boolean;
  scoreModal: AdminTournamentScoreModalState | null;
  setMatchupModal: Dispatch<
    SetStateAction<AdminTournamentMatchupModalState | null>
  >;
  setScoreModal: Dispatch<SetStateAction<AdminTournamentScoreModalState | null>>;
};

export default function AdminTournamentOperationsModals({
  manualPairs,
  matchupModal,
  onCloseMatchup,
  onCloseScore,
  onSaveMatchup,
  onSaveScore,
  saving,
  scoreModal,
  setMatchupModal,
  setScoreModal,
}: AdminTournamentOperationsModalsProps) {
  const matchupModalContent = matchupModal ? (
    <AdminTournamentMatchupModal
      manualPairs={manualPairs}
      modal={matchupModal}
      onClose={onCloseMatchup}
      onSave={onSaveMatchup}
      saving={saving}
      setModal={setMatchupModal}
    />
  ) : null;

  const scoreModalContent = scoreModal ? (
    <AdminTournamentScoreModal
      modal={scoreModal}
      onClose={onCloseScore}
      onSave={onSaveScore}
      saving={saving}
      setModal={setScoreModal}
    />
  ) : null;

  return (
    <>
      {matchupModalContent && typeof document !== "undefined"
        ? createPortal(matchupModalContent, document.body)
        : matchupModalContent}

      {scoreModalContent && typeof document !== "undefined"
        ? createPortal(scoreModalContent, document.body)
        : scoreModalContent}
    </>
  );
}
